// Module
var code = "<div class=\"InboxTicketSkeleton\"> <div class=\"InboxTicketSkeleton__avatar\"></div> <div class=\"InboxTicketSkeleton__body\"> <div class=\"InboxTicketSkeleton__bodySubject\"></div> <div class=\"InboxTicketSkeleton__bodyContent\"></div> <div class=\"InboxTicketSkeleton__bodyTimestamp\"></div> </div> </div> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/components/header/inboxMenu/inboxTicketSkeleton/inboxTicketSkeleton.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;